import { Link } from 'react-router-dom';
import { useViewTransitionNavigate } from '../../hooks/useViewTransitionNavigate';
import ShopItem from './ShopItem';

const IllustrationData = ({ data, isLoading }) => {
  if (isLoading) return;
  const navigateWithTransition = useViewTransitionNavigate();

  return (
    <>

      {data.map((illustration) => (
        <div key={illustration._id}>
          <div onClick={() =>
            navigateWithTransition(`/illustrations/${illustration._id}`, "forwards")
          }>
            <Link to={`/illustrations/${illustration._id}`}>
              <ShopItem
                id={illustration.id}
                url={illustration.image}
                name={illustration.title}
              />
            </Link>
          </div>
        </div>
      ))}
    </>
  );
};

export default IllustrationData;
